import { render, staticRenderFns } from "./login-layout-change-password.vue?vue&type=template&id=56378df2&scoped=true&"
import script from "./login-layout-change-password.ts?vue&type=script&lang=ts&"
export * from "./login-layout-change-password.ts?vue&type=script&lang=ts&"
import style0 from "./login-layout-change-password.scss?vue&type=style&index=0&id=56378df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56378df2",
  null
  
)

export default component.exports